// ============================================================
//  Qbrix Theme — Global JS utilities
//  Loaded on all pages: brick utils, header/menu, UTM topbar
// ============================================================

// Utilities (brick generation)
const rnd = (a, b) => Math.random() * (b - a) + a;
const pick = arr => arr[Math.floor(Math.random() * arr.length)];

// BRICK_HEX_MAP uses Shopify asset URLs injected by qbrix-assets-map.liquid
// window.QbrixAssets must be defined before this script runs
const BRICK_HEX_MAP = {
  'e02f85': window.QbrixAssets && window.QbrixAssets['brick-retrowave-1-pink'],
  '4a275d': window.QbrixAssets && window.QbrixAssets['brick-retrowave-2-purple'],
  '1a2642': window.QbrixAssets && window.QbrixAssets['brick-retrowave-3-navy'],
  'b2d9c0': window.QbrixAssets && window.QbrixAssets['brick-retrowave-4-mint'],
  'f8c000': window.QbrixAssets && window.QbrixAssets['brick-retrowave-5-yellow'],
  '121212': window.QbrixAssets && window.QbrixAssets['brick-original-1-black'],
  '333f48': window.QbrixAssets && window.QbrixAssets['brick-original-2-navy'],
  'f4f2e7': window.QbrixAssets && window.QbrixAssets['brick-original-3-cream'],
  '63666a': window.QbrixAssets && window.QbrixAssets['brick-original-4-slate'],
  'b8b298': window.QbrixAssets && window.QbrixAssets['brick-original-5-taupe'],
  '00263a': window.QbrixAssets && window.QbrixAssets['brick-poster-2-darknavy'],
  'e793b7': window.QbrixAssets && window.QbrixAssets['brick-poster-3-pink'],
  'fae8b8': window.QbrixAssets && window.QbrixAssets['brick-poster-4-peach'],
  'fae053': window.QbrixAssets && window.QbrixAssets['brick-solar-2-yellow'],
  'dd7975': window.QbrixAssets && window.QbrixAssets['brick-solar-3-coral'],
  'a4343a': window.QbrixAssets && window.QbrixAssets['brick-solar-4-red'],
};
function brickSrc(hex) {
  return BRICK_HEX_MAP[hex] || BRICK_HEX_MAP['e02f85'];
}

// Brand color constants
const BRAND_COLORS = {
  fuchsia: '#E02F85',
  yellow:  '#F8C100',
  mint:    '#B1D9C0',
  cream:   '#E0D9D5',
  navy:    '#192642',
  purple:  '#4B275E',
  bgBase:  '#06060A',
  bgDark:  '#0B0B12',
  white:   '#ffffff',
};
const Bricks = {
  fuchsia: brickSrc('e02f85'),
  purple:  brickSrc('4a275d'),
  navy:    brickSrc('1a2642'),
  mint:    brickSrc('b2d9c0'),
  yellow:  brickSrc('f8c000'),
  black:   brickSrc('121212'),
  cream:   brickSrc('f4f2e7'),
  pink:    brickSrc('e793b7'),
  peach:   brickSrc('fae8b8')
};
const BRICK_RETROWAVE = [Bricks.fuchsia, Bricks.purple, Bricks.navy, Bricks.mint, Bricks.yellow];

function mkBrick(src, size, opacity) {
  const img = document.createElement('img');
  img.src = src;
  img.className = 'brick';
  img.style.cssText = `width:${size}px;height:${size}px;opacity:${opacity};`;
  img.loading = 'lazy';
  return img;
}

// vd17 phone mask and submit handlers — must be global (called from HTML attributes)
function vd17Mask(input) {
  // Strip everything non-digit
  let raw = input.value.replace(/\D/g, '');

  // Remove leading 62 or 0 if user pasted full number
  if (raw.startsWith('62')) raw = raw.slice(2);
  if (raw.startsWith('0'))  raw = raw.slice(1);

  // Enforce leading 8 — Indonesian mobile numbers start with 8
  if (raw.length > 0 && raw[0] !== '8') raw = '8' + raw;

  // Cap at 12 digits total (8 + up to 11 digits = covers all operators)
  raw = raw.slice(0, 12);

  // Format: +62 (8XX) XXXX-XXXX
  let out = '';
  if (raw.length === 0) {
    out = '';
  } else if (raw.length <= 3) {
    out = '+62 (' + raw;
  } else if (raw.length <= 7) {
    out = '+62 (' + raw.slice(0,3) + ') ' + raw.slice(3);
  } else {
    out = '+62 (' + raw.slice(0,3) + ') ' + raw.slice(3,7) + '-' + raw.slice(7);
  }

  input.value = out;
}

function vd17KeyDown(e, input) {
  // Allow Backspace to work naturally through raw value
  if (e.key === 'Backspace') {
    const raw = input.value.replace(/\D/g, '').replace(/^62/, '').replace(/^0/, '');
    if (raw.length <= 1) { input.value = ''; e.preventDefault(); }
  }
}

function vd17Submit(e) {
  e.preventDefault();
  const input = document.getElementById('vd17-input');
  const raw = input.value.replace(/\D/g, '');
  // Need at least 10 digits (62 + 8 + 7 min)
  if (raw.length < 10) {
    input.style.borderColor = BRAND_COLORS.fuchsia;
    input.focus();
    setTimeout(() => { input.style.borderColor = ''; }, 1500);
    return;
  }

  const userPhone = '62' + raw;

  // Fire-and-forget to backend lead capture
  fetch('https://api.qbrix.co.id/api/wheel-lead', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Wheel-Token': '7adf4cd3eb08be12f493cc548e2d6de9093523e9227cd0d569c6a3c7b2d91591'
    },
    body: JSON.stringify({ phone: userPhone })
  }).catch(function() {});

  document.getElementById('vd17-form').classList.add('hidden');
  document.getElementById('vd17-success').classList.remove('hidden');
}

async function checkPromoStatus() {
  var phone = '';
  var promo  = '';
  try {
    phone = localStorage.getItem('qbrix_wheel_phone') || '';
    promo = localStorage.getItem('qbrix_wheel_promo') || '';
  } catch(e) {}
  if (!phone || promo) return;
  try {
    var resp = await fetch('https://api.qbrix.co.id/api/promo-status?phone=' + encodeURIComponent(phone));
    if (!resp.ok) return;
    var data = await resp.json();
    if (data.status === 'wa_replied' && data.promo_code) {
      try { localStorage.setItem('qbrix_wheel_promo', data.promo_code); } catch(e) {}
      // НЕ делаем reload — при следующей загрузке initTopbarPromo() подхватит состояние A
    }
  } catch(e) {}
}

document.addEventListener('DOMContentLoaded', () => {

  // 1. UTM Topbar Close
  const topbar = document.getElementById('utm-topbar');
  const closeTopbar = document.getElementById('close-topbar');
  const nav = document.getElementById('main-nav');
  if (closeTopbar) {
    closeTopbar.addEventListener('click', () => {
      topbar.style.transform = 'translateY(-100%)';
      setTimeout(() => {
        topbar.style.display = 'none';
        nav.style.top = '0'; // lift nav up
      }, 300);
    });
  }

  // 1b. UTM Topbar Promo State
  function initTopbarPromo() {
    var wheelPromo = '';
    var wheelPhone = '';
    try {
      wheelPromo = localStorage.getItem('qbrix_wheel_promo') || '';
      wheelPhone = localStorage.getItem('qbrix_wheel_phone') || '';
    } catch(e) {}

    var hasPromoEl = document.getElementById('utm-topbar-has-promo');
    var noPromoEl  = document.getElementById('utm-topbar-no-promo');
    var pendingEl  = document.getElementById('utm-topbar-pending');
    if (!hasPromoEl || !noPromoEl) return;

    if (wheelPromo) {
      // Состояние A
      var label = document.getElementById('utm-promo-code-label');
      if (label) label.textContent = wheelPromo;
      hasPromoEl.style.display = 'flex';

      var promoCode = '';
      try { promoCode = localStorage.getItem('qbrix_promo_code') || ''; } catch(e) {}

      var pakaiBtn = document.getElementById('utm-pakai-btn');
      if (pakaiBtn) {
        // setAktifText — updates <p> without innerHTML to avoid XSS from localStorage value
        function setAktifText() {
          var p = hasPromoEl.querySelector('p');
          if (!p) return;
          p.textContent = '';
          var t1 = document.createTextNode('🎰 Kode ');
          var strong = document.createElement('strong');
          strong.style.fontFamily = 'monospace';
          strong.style.fontWeight = '800';
          strong.textContent = wheelPromo;
          var t2 = document.createTextNode(' — aktif di keranjang!');
          p.appendChild(t1);
          p.appendChild(strong);
          p.appendChild(t2);
        }
        if (promoCode) {
          // Уже активирован — сразу показать Aktif
          pakaiBtn.textContent = '✓ Aktif';
          pakaiBtn.style.background = '#22c55e';
          pakaiBtn.style.color = '#fff';
          pakaiBtn.disabled = true;
          setAktifText();
        } else {
          pakaiBtn.addEventListener('click', function() {
            try { localStorage.setItem('qbrix_promo_code', wheelPromo); } catch(e) {}
            var cartInput = document.getElementById('cart-promo-input');
            if (cartInput) cartInput.value = wheelPromo;
            pakaiBtn.textContent = '✓ Aktif';
            pakaiBtn.style.background = '#22c55e';
            pakaiBtn.style.color = '#fff';
            pakaiBtn.disabled = true;
            setAktifText();
          });
        }
      }
    } else if (wheelPhone && !wheelPromo) {
      // Состояние C — номер есть, промо ещё не получен
      if (pendingEl) pendingEl.style.display = 'flex';
    } else {
      // Состояние B
      noPromoEl.style.display = 'flex';
      var putarBtn = document.getElementById('utm-putar-btn');
      if (putarBtn) {
        putarBtn.addEventListener('click', function() {
          if (typeof showWheel === 'function') showWheel();
          else window.location.href = '/#wheel';
        });
      }
    }
  }
  initTopbarPromo();
  checkPromoStatus(); // async, не блокирует

  // 2. Mobile menu
  const menuBtn = document.getElementById('mobile-menu-btn');
  const mobileMenu = document.getElementById('mobile-menu');
  const iconBars = document.getElementById('menu-icon-bars');
  const iconClose = document.getElementById('menu-icon-close');

  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
      iconBars.classList.toggle('hidden');
      iconClose.classList.toggle('hidden');
    });
  }

  // 2b. Mobile cart dropdown toggle
  const cartBtnMobile = document.getElementById('cart-btn-mobile');
  const cartDropdownMobile = document.getElementById('cart-dropdown-mobile');

  if (cartBtnMobile && cartDropdownMobile) {
    cartBtnMobile.addEventListener('click', (e) => {
      e.stopPropagation();
      cartDropdownMobile.classList.toggle('hidden');
      // Close mobile menu if open
      if (mobileMenu && !mobileMenu.classList.contains('hidden')) {
        mobileMenu.classList.add('hidden');
        if (iconBars) iconBars.classList.remove('hidden');
        if (iconClose) iconClose.classList.add('hidden');
      }
    });
    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!cartBtnMobile.contains(e.target) && !cartDropdownMobile.contains(e.target)) {
        cartDropdownMobile.classList.add('hidden');
      }
    });
  }

  // 3. Hero background: 1B Dense Center Void
  const init1B = () => {
    const c = document.getElementById('cont-1b');
    if(!c) return;
    const f = document.createDocumentFragment();
    // Reduce brick count on mobile for performance
    const count = window.innerWidth < 768 ? 40 : 70;
    for (let i = 0; i < count; i++) {
      let x, y;
      const z = Math.random();
      if      (z < 0.25) { x = rnd(0,100); y = rnd(0,20); }
      else if (z < 0.50) { x = rnd(0,100); y = rnd(80,100); }
      else if (z < 0.75) { x = rnd(0,20);  y = rnd(0,100); }
      else               { x = rnd(80,100); y = rnd(0,100); }

      const dx = Math.abs(x-50)/50, dy = Math.abs(y-50)/50;
      const edge = Math.sqrt(dx*dx + dy*dy);
      const opacity = 0.05 + edge * 0.25;
      const size = pick([24, 28, 32, 36, 40]);
      const src  = pick(BRICK_RETROWAVE);
      const b = mkBrick(src, size, opacity);
      b.style.left = `${x}%`; b.style.top = `${y}%`;
      const dur = rnd(10,17), delay = rnd(-17,0);
      if (edge > 0.9) {
        b.style.setProperty('--base-opacity', opacity);
        b.style.animation = `float ${dur}s ease-in-out ${delay}s infinite, pulse-opacity ${rnd(4,8)}s ease-in-out ${delay}s infinite`;
      } else {
        b.style.animation = `float ${dur}s ease-in-out ${delay}s infinite`;
      }
      b.style.willChange = 'transform';
      f.appendChild(b);
    }
    c.appendChild(f);
  };
  init1B();

  // 4. Section headers A2 and B3 (scroll animation)
  const hdrObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) entry.target.classList.add('hdr-in-view');
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('.hdr-observe').forEach(el => hdrObserver.observe(el));

  // V-D10: Cara kerjanya — trigger brick animations on scroll
  const vd10Section = document.querySelector('.vd10-path-wrap')?.closest('section');
  if (vd10Section) {
    let vd10Fired = false;
    const vd10Observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !vd10Fired) {
          vd10Fired = true;
          vd10Section.querySelectorAll('.vd10-b, .vd10-tip').forEach(el => {
            el.style.animation = 'none';
            void el.offsetWidth;
            el.style.animation = '';
          });
        }
      });
    }, { threshold: 0.3 });
    vd10Observer.observe(vd10Section);
  }

  // 5. Palette Switcher (Block 5)
  const paletteBtns = document.querySelectorAll('.palette-btn');
  const palettePreview = document.getElementById('palette-preview');
  const paletteName = document.getElementById('palette-name');

  paletteBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      paletteBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const palette = btn.dataset.palette;
      palettePreview.className = 'flex-1 mt-4 lg:mt-0 min-h-[200px] lg:min-h-full palette-preview rounded-xl overflow-hidden transition-all duration-500 flex items-center justify-center border border-white/10 relative palette-' + palette;
      paletteName.textContent = btn.querySelector('.palette-label').textContent;
    });
  });
  // Activate first palette button
  if(paletteBtns.length > 0) paletteBtns[0].click();

  // 6. Divider: Orbit
  const initDividerOrbit = () => {
    const container = document.getElementById('divider-v2-container');
    if (!container) return;
    const count = 14;
    const radiusX = Math.min(140, Math.floor(container.getBoundingClientRect().width / 2) - 20);
    const radiusY = 50;
    const ALL_BRICKS = ['e02f85','4a275d','1a2642','b2d9c0','f8c000','121212','f4f2e7','e793b7','fae8b8'];

    for (let i = 0; i < count; i++) {
      const img = document.createElement('img');
      img.src = brickSrc(ALL_BRICKS[i % ALL_BRICKS.length]);
      img.className = 'v2-brick pointer-events-none w-8 h-8';

      const angle = (i / count) * Math.PI * 2;
      const orbitX = `calc(50% + ${Math.cos(angle) * radiusX}px)`;
      const orbitY = `calc(50% + ${Math.sin(angle) * radiusY}px)`;
      const containerW = container.getBoundingClientRect().width;
      const maxOffset = Math.floor(containerW / 2) - 20;
      const rawOffset = (i - count / 2 + 0.5) * 34;
      const clampedOffset = Math.min(maxOffset, Math.max(-maxOffset, rawOffset));
      const lineX  = `calc(50% + ${clampedOffset}px)`;
      const rot    = (Math.random() * 180 - 90).toFixed(1);
      const delay  = (i % 3) * 100;

      img.style.setProperty('--orbit-x', orbitX);
      img.style.setProperty('--orbit-y', orbitY);
      img.style.setProperty('--line-x',  lineX);
      img.style.setProperty('--rot',     `${rot}deg`);
      img.style.setProperty('--delay',   `${delay}ms`);
      container.appendChild(img);
    }

    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.remove('divider-out');
          e.target.classList.add('divider-in');
        } else {
          e.target.classList.remove('divider-in');
          e.target.classList.add('divider-out');
        }
      });
    }, { threshold: 0.6 });
    obs.observe(container);
  };
  initDividerOrbit();

  // 7. Divider: Assembly Snap
  let v5DemoTimer = null;
  const initDividerAssembly = () => {
    const container = document.getElementById('v5-demo-slots');
    if (!container) return;
    const slots = 9;
    const HEX_RETROWAVE = ['e02f85','4a275d','1a2642','b2d9c0','f8c000'];
    container.innerHTML = '';
    for (let i = 0; i < slots; i++) {
      const slot = document.createElement('div');
      slot.className = 'v5-slot';
      const img = document.createElement('img');
      img.src = brickSrc(HEX_RETROWAVE[i % HEX_RETROWAVE.length]);
      img.className = 'v5-brick-item pointer-events-none w-8 h-8';
      slot.appendChild(img);
      container.appendChild(slot);
    }

    const runV5Demo = () => {
      const wrap = document.getElementById('v5-demo-wrap');
      if (!wrap || container.dataset.animating === 'true') return;
      container.dataset.animating = 'true';

      const bricks = container.querySelectorAll('.v5-brick-item');
      wrap.classList.remove('is-glowing');
      bricks.forEach(b => b.classList.remove('is-placed'));

      bricks.forEach((b, i) => {
        setTimeout(() => b.classList.add('is-placed'), i * 150);
      });

      const finishTime = bricks.length * 150 + 200;
      v5DemoTimer = setTimeout(() => {
        wrap.classList.add('is-glowing');
        setTimeout(() => {
          bricks.forEach(b => b.classList.remove('is-placed'));
          wrap.classList.remove('is-glowing');
          setTimeout(() => {
            container.dataset.animating = 'false';
            runV5Demo();
          }, 600);
        }, 3000);
      }, finishTime);
    };

    const obs = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) runV5Demo();
    }, { threshold: 0.6 });
    obs.observe(container);
  };
  initDividerAssembly();

});
